class AuthManager {
  static __local__storage_key = "Compatio.consolidated.GMS.Logged.user.Object";
  static __local__storage_isAdmin_key =
    "Compatio.consolidated.GMS.Logged.user.isAdmin.Object";
  static __local__storage_permissions_key =
    "Compatio.consolidated.GMS.Logged.User.Permissions.Object";
  static __local__storage_sams_token_key =
    "Compatio.consolidated.GMS.sams.Object";
  static __local__storage_gms_token_key = "Compatio.consolidated.GMS.Object";
  static __local__storage_workspace_good_key =
    "Compatio.consolidated.GMS.Workspace.good";

  static setAuthUser(value) {
    sessionStorage.setItem(this.__local__storage_key, JSON.stringify(value));
    localStorage.setItem(this.__local__storage_key, JSON.stringify(value));
  }
  static setSamsToken(value) {
    sessionStorage.setItem(this.__local__storage_sams_token_key, value);
    localStorage.setItem(this.__local__storage_sams_token_key, value);
  }
  static setGmsToken(value) {
    sessionStorage.setItem(this.__local__storage_gms_token_key, value);
    localStorage.setItem(this.__local__storage_gms_token_key, value);
  }
  static setWorkspaceStatus(value) {
    sessionStorage.setItem(this.__local__storage_workspace_good_key, value);
    localStorage.setItem(this.__local__storage_workspace_good_key, value);
  }
  static setAuthUser_IsAdmin(value) {
    sessionStorage.setItem(this.__local__storage_isAdmin_key, value);
    localStorage.setItem(this.__local__storage_isAdmin_key, value);
  }

  static setPermissions(value) {
    sessionStorage.setItem(
      this.__local__storage_permissions_key,
      JSON.stringify(value)
    );
    localStorage.setItem(
      this.__local__storage_permissions_key,
      JSON.stringify(value)
    );
  }

  static getAuthUser_IsAdmin() {
    if(this.isIsAdminTokenReceivedSession() && this.isIsAdminTokenReceived()){
      return sessionStorage.getItem((this.__local__storage_isAdmin_key))
    }
    else{
      if (this.isIsAdminTokenReceived()){
        const data = localStorage.getItem(this.__local__storage_isAdmin_key);
        sessionStorage.setItem(this.__local__storage_isAdmin_key,data)
        return data
      }
      else{
        this.clearSessionStorage()
      }
    }
    return null;
  }

  static getPermissions() {
    if(this.isPermisisonsReceivedSession() && this.isPermisisonsReceived()){
      return JSON.parse(sessionStorage.getItem((this.__local__storage_permissions_key)))
    }
    else{
      if (this.isPermisisonsReceived()){
        const data = localStorage.getItem(this.__local__storage_permissions_key);
        sessionStorage.setItem(this.__local__storage_permissions_key,data)
        return JSON.parse(data)
      }
      else{
        this.clearSessionStorage()
      }
    }
    return null;
  }

  static getAuthUser() {
    if(this.isAuthenticatedSession() && this.isAuthenticated()){
      return  JSON.parse(sessionStorage.getItem((this.__local__storage_key)))
    }
    else{
      if (this.isAuthenticated()){
        const data = localStorage.getItem(this.__local__storage_key);
        sessionStorage.setItem(this.__local__storage_key,data)
        return  JSON.parse(data)
      }
      else{
        this.clearSessionStorage()
      }
    }
    return null;
  }

  static getSamsToken() {
    if(this.isSamsTokenReceivedSession() && this.isSamsTokenReceived()){
      return sessionStorage.getItem((this.__local__storage_sams_token_key))
    }
    else{
      if (this.isSamsTokenReceived()){
        const data = localStorage.getItem(this.__local__storage_sams_token_key);
        sessionStorage.setItem(this.__local__storage_sams_token_key,data)
        return data
      }
      else{
        this.clearSessionStorage()
      }
    }
    return null;
  }

  static getWorkSpaceStatus() {
    if(this.isWorkSpaceStatusGoodSession() && this.isWorkSpaceStatusGood()){
      return sessionStorage.getItem((this.__local__storage_workspace_good_key))
    }
    else{
      if (this.isWorkSpaceStatusGood()){
        const data = localStorage.getItem(this.__local__storage_workspace_good_key);
        sessionStorage.setItem(this.__local__storage_workspace_good_key,data)
        return data
      }
      else{
        this.clearSessionStorage()
      }
    }
    return null;
  }

  static getGmsToken() {
    if(this.isGmsTokenReceivedSession() && this.isGmsTokenReceived()){
      return sessionStorage.getItem((this.__local__storage_gms_token_key))
    }
    else{
      if (this.isGmsTokenReceived()){
        const token = localStorage.getItem(this.__local__storage_gms_token_key);
        sessionStorage.setItem(this.__local__storage_gms_token_key,token)
        return token
      }
      else{
        this.clearSessionStorage()
      }
    }
    return null;
  }

  static isAuthenticated() {
    return this.__local__storage_key in localStorage;
  }

  static isSamsTokenReceived() {
    return this.__local__storage_sams_token_key in localStorage;
  }

  static isWorkSpaceStatusGood() {
    return this.__local__storage_workspace_good_key in localStorage;
  }

  static isGmsTokenReceived() {
    return this.__local__storage_gms_token_key in localStorage;
  }

  static isIsAdminTokenReceived() {
    return this.__local__storage_isAdmin_key in localStorage;
  }

  static isPermisisonsReceived() {
    return this.__local__storage_permissions_key in localStorage;
  }

  static isAuthenticatedSession() {
    return this.__local__storage_key in sessionStorage;
  }

  static isSamsTokenReceivedSession() {
    return this.__local__storage_sams_token_key in sessionStorage;
  }

  static isWorkSpaceStatusGoodSession() {
    return this.__local__storage_workspace_good_key in sessionStorage;
  }

  static isIsAdminTokenReceivedSession() {
    return this.__local__storage_isAdmin_key in sessionStorage;
  }
  
  static isPermisisonsReceivedSession() {
    return this.__local__storage_permissions_key in sessionStorage;
  }
  static isGmsTokenReceivedSession(){
    return this.__local__storage_gms_token_key in sessionStorage ;
  }

  static clearSessionStorage(){
    if(this.isAuthenticatedSession()){
      sessionStorage.removeItem(this.__local__storage_key);
      sessionStorage.removeItem(this.__local__storage_sams_token_key);
      sessionStorage.removeItem(this.__local__storage_isAdmin_key);
      sessionStorage.removeItem(this.__local__storage_permissions_key);
    }
    sessionStorage.clear()
  }

  static logoutUser() {
    if (this.isAuthenticated()) {
      localStorage.removeItem(this.__local__storage_key);
      localStorage.removeItem(this.__local__storage_sams_token_key);
      localStorage.removeItem(this.__local__storage_isAdmin_key);
      localStorage.removeItem(this.__local__storage_permissions_key);
    }
    if(this.isAuthenticatedSession()){
      sessionStorage.removeItem(this.__local__storage_key);
      sessionStorage.removeItem(this.__local__storage_sams_token_key);
      sessionStorage.removeItem(this.__local__storage_isAdmin_key);
      sessionStorage.removeItem(this.__local__storage_permissions_key);
    }
    localStorage.clear();
    sessionStorage.clear();
  }
}

export default AuthManager;
